import React from "react";
import styles from "./styles.module.scss";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { CircularProgress } from "../../../../../../shared/CircularProgress/CircularProgress";
import { Button } from "../../../../../../shared/Button/Button";

/**
 * @typedef {{
 *  initiate: () => Promise<void>;
 *  isLoading: boolean;
 *  isDisabled: boolean;
 * }} SubmitAction
 * @param {{
 *  onCancel: () => void,
 *  sendOtp: SubmitAction;
 *  verifyOtp: SubmitAction;
 * }} param0
 */
export function Footer({ onCancel, sendOtp, verifyOtp }) {
  const { tAuth: t } = useAppTranslation.Auth({
    keyPrefix: "twoFactor.alternativeOtp",
  });

  return (
    <div className={styles.root}>
      {!!sendOtp && (
        <Button
          isDisabled={sendOtp.isLoading || sendOtp.isDisabled}
          onClick={sendOtp.initiate}
          leftAdornment={
            sendOtp.isLoading ? (
              <CircularProgress size="small" color="white" />
            ) : undefined
          }
        >
          {t("sendOtp")}
        </Button>
      )}
      {!!verifyOtp && (
        <Button
          isDisabled={verifyOtp.isLoading || verifyOtp.isDisabled}
          onClick={verifyOtp.initiate}
          leftAdornment={
            verifyOtp.isLoading ? (
              <CircularProgress size="small" color="white" />
            ) : undefined
          }
        >
          {t("verify")}
        </Button>
      )}
      <Button variant="outlined" onClick={onCancel}>
        {t("cancel")}
      </Button>
    </div>
  );
}
